import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  getAllActivePaymentMode,
  getEmprCancellationList,
  submitstatusHandler,
} from "./utils";
import ListComponent from "./ListComponent";
import { ReactComponent as BackArrow } from "../../../../../../assets/img/svg/BackArrow.svg";
import { useHistory } from "react-router-dom";
import { Card } from "reactstrap";
import ShowOnlyPendingRequestsCheckbox from "../paymodeApproval/ShowOnlyPendingRequestsCheckbox";
import AMultiFieldSearchInput from "components/AMultiFieldSearchInput/AMultiFieldSearchInput";
import {
  initialForm,
  initialInputFilter,
  searchInputOptions,
  setConfigOnRows,
  status,
  statusDropdown,
  statusMappingAprroval,
  statusMappingRejection,
} from "./constant";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import FilterForm from "./FilterForm";
import { useGetAllBusinessArea } from "views/pages/manage/businessArea/component/FirstForm/FeatureSetup/utils";
import ConfirmRejectionDialog from "./ConfirmRejectionDialog";
import ConfirmApprovalDialog from "./ConfirmApprovalDialogDetail";
import ALoader from "views/pages/manage/common/a-loader";
import { getConfigs } from "views/pages/manage/masters/studentFinancials/epmrConfigs/service";

import { PermissionContext } from "appContext";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const EPMRCancellation = () => {
  const history = useHistory();
  const businessAreaDropdown = useSelector(
    (state) => state.globalData.masterDropdowns
  )?.allBusinessAreaList.map(({ label, businessAreaId }) => ({
    label,
    value: businessAreaId,
    businessAreaId,
  }));

  const permissionData = useContext(PermissionContext);

  const [loader, setLoader] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [rows, setRows] = useState([]);
  const [showOnlyPendingRequests, setShowOnlyPendingRequests] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(initialForm);
  const [dropdowns, setDropdowns] = useState({});
  const [filterCount, setFilterCount] = useState();
  const [isOpen, setOpen] = useState(false);
  const [detail, setDetail] = useState({});
  const [approvalOpen, setApprovalOpen] = useState(false);

  useEffect(() => {
    Array.isArray(businessAreaDropdown) &&
      businessAreaDropdown.length > 0 &&
      searchHandler(0, { status: status });
    getAllDropdown();
  }, []);

  const getAllDropdown = async () => {
    setLoader(true);
    const paymodeDropdown = await getAllActivePaymentMode();

    setDropdowns({
      status: statusDropdown,
      paymode: paymodeDropdown,
    });
    setLoader(false);
  };
  const searchHandler = async (page = 0, req = { status: status }) => {
    const configData = await getConfigs();
    const data = await getEmprCancellationList(
      page,
      req,
      setLoader,
      businessAreaDropdown
    );
    const comfigEnabledData = setConfigOnRows(
      permissionData?.roleType,
      data?.epmrReceiptList,
      configData
    );
    setPaginationData({
      currentPage: data?.currentPage,
      totalPage: data?.totalPage,
      totalRecords: data?.totalRecords,
    });

    setRows(comfigEnabledData);
  };
  const pageHandler = (page) => {
    searchHandler(page);
  };
  const searchInputHandler = (selectedField, inputValue) => {
    const status = globalFilter?.pendingOnly ? { staus: [] } : {};
    searchHandler(0, {
      ...globalFilter,
      ...status,
      ...initialInputFilter,
      [selectedField]: inputValue,
      pendingOnly: false,
    });
    setGlobalFilter((prev) => ({
      ...prev,
      ...status,
      ...initialInputFilter,
      [selectedField]: inputValue,
      pendingOnly: false,
    }));
    setShowOnlyPendingRequests(false);
  };
  const showOnlyPendingRequestsHandler = (checked) => {
    setShowOnlyPendingRequests(checked);
    if (checked) {
      searchHandler(0, { status: [{ label: "Pending", value: "PENDING" }] });
      setGlobalFilter({ pendingOnly: true });
      setFilterCount(0);
    } else {
      searchHandler(0, { status });
      setGlobalFilter(initialForm);
      setFilterCount(0);
    }
  };
  const crossHandler = () => {
    searchHandler(0, { ...globalFilter, ...initialInputFilter });
    setGlobalFilter((prev) => ({ ...prev, ...initialInputFilter }));
  };
  const actionHandler = (rowData, action) => {
    setDetail(rowData);
    action == "reject" ? setOpen(true) : setApprovalOpen(true);
  };
  const statusHandler = async (rowData, approverRemark, action) => {
    const req = {
      approvalStatus:
        action == "REJECT"
          ? statusMappingRejection[(rowData?.status).toUpperCase()]
          : statusMappingAprroval[(rowData?.status).toUpperCase()],
      epmrNumber: rowData?.epmrNumber,
      approverRemark,
    };
    try {
      setLoader(true);
      const res = await submitstatusHandler(req);
      if (res?.code == 200) {
        successToast(res?.message);
        setOpen(false);
        setApprovalOpen(false);
        searchHandler(0, { status });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Card className="m-3 p-2">
        <div className="d-flex justify-content-between">
          <div>
            <BackArrow
              className="mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h3 className="d-inline">EPMR Cancellation Requests</h3>
            {!loader && rows?.length > 0 && (
              <span
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  padding: "5px",
                  marginLeft: "0.5rem",
                  backgroundColor: "#f5f5f5",
                  lineHeight: "1.3",
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                {rows.length}
              </span>
            )}
          </div>

          <div
            className="d-flex justify-content-between"
            style={{ columnGap: "10px" }}
          >
            <ShowOnlyPendingRequestsCheckbox
              checked={showOnlyPendingRequests}
              showOnlyPendingRequestsHandler={showOnlyPendingRequestsHandler}
            />
            <AMultiFieldSearchInput
              options={searchInputOptions}
              searchHandler={searchInputHandler}
              crossHandler={crossHandler}
            />
            <APopover
              buttonComponent={(openPopover, styles) => (
                <AButton
                  className="tiny-semi-bold color-dark"
                  onClick={openPopover}
                  size="xs"
                  updatedStyle={{
                    minWidth: "61px",
                    ...(filterCount > 0
                      ? {
                          border: "1px solid #00B0F5",
                          color: "#00B0F5",
                        }
                      : styles),
                  }}
                >
                  Filters {filterCount > 0 ? `(${filterCount})` : ""}
                </AButton>
              )}
              menuComponent={(closePopup) => (
                <FilterForm
                  closeForm={closePopup}
                  dropdowns={{ ...dropdowns, bu: businessAreaDropdown }}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  setShowOnlyPendingRequests={setShowOnlyPendingRequests}
                  searchHandler={searchHandler}
                  filterCount={filterCount}
                  setFilterCount={setFilterCount}

                  //filterCount={getFilterCount()}
                />
              )}
            />
          </div>
        </div>
        {(loader || !businessAreaDropdown?.length) && (
          <ALoader position="fixed" />
        )}
        <ListComponent
          paginationData={paginationData}
          loading={loader}
          rows={rows}
          actionHandler={actionHandler}
          pageHandler={pageHandler}
          businessAreaDropdown={businessAreaDropdown}
        />
      </Card>
      <ConfirmRejectionDialog
        isOpen={isOpen}
        setOpen={setOpen}
        rejectionDetail={detail}
        statusHandler={statusHandler}
      />
      <ConfirmApprovalDialog
        isOpen={approvalOpen}
        setOpen={setApprovalOpen}
        approvalDetail={detail}
        statusHandler={statusHandler}
      />
    </>
  );
};
export default EPMRCancellation;
